module.exports = __webpack_public_path__ + "media/images/bb_basico-82f569f49c3a3f5ac2978084ff2605fe.png";